import axios from 'axios';
import { CURRENT_API_URL } from "../../../../Utils/Constants";
import notify from '../../../../Notifications/ToastifyActions';


function PMUpdateArchiveNotificationsService(token, data ) {
    return axios.post(`${CURRENT_API_URL}/proactiveMonitoring/PMarchiveMessage`, data,{
        headers: {
            'Authorization': token,
        }
        }).then(res => {
                 
            return res.data;        
        }).catch(error => {
            console.log(error);
            notify.NotifyError("An error occurred while updating the Archive notification. Please try again later");
            return false;
        });
    }

export default PMUpdateArchiveNotificationsService;